import { Box, Paper, PaperProps, Typography } from "@mui/material";
import CustomMDEditor from "../../../components/CustomMD/CustomMDEditor";
import CustomMDPreview from "../../../components/CustomMD/CustomMDPreview";
import { User } from "../../../types/User";
interface AboutMeProps {
    userData: User;
    setUserData: React.Dispatch<React.SetStateAction<User | null>>;
    editMode: boolean;
    paperProps?: PaperProps;
}

const AboutMe = ({
    userData,
    setUserData,
    editMode,
    paperProps,
}: AboutMeProps) => {
    const handleDescriptionChange = (value?: string) => {
        setUserData((prevData) => {
            if (!prevData) return null;
            return {
                ...prevData,
                description: value || ""
            };
        });
    };

    return (
        <Paper {...paperProps} sx={{ padding: 2, mb: 3, borderRadius: 2, ...paperProps?.sx }}>
            <Box>
                <Typography variant="h6" mb={3}>
                    About Me
                </Typography>
                {editMode ? (
                    <CustomMDEditor
                        value={userData.description || ""}
                        onChange={handleDescriptionChange}
                        placeholder={
                            `Tell clients about yourself, your work experience, and why they should hire you`
                        }
                        customStyles={{
                            width: '100%',
                        }}
                    />
                ) : (
                    <CustomMDPreview description={userData.description || "No Description provided yet."} />
                )}
            </Box>
        </Paper>
    );
};

export default AboutMe; 